import React from 'react';
import Card from './Card';
import Icon from './Icon';
import './AccessState.css';

// PRD-1699: what a user sees in place of a page their role doesn't allow, and when
// their role allows nothing yet. Wording is a placeholder until Design approves it.
const COPY = {
  'not-available': {
    icon: 'lock',
    title: "This page isn't available",
    body: "Your role doesn't include this page. If you need it, ask your administrator.",
  },
  'nothing-set-up': {
    icon: 'user-circle',
    title: "Your access isn't set up yet",
    body: 'Your role doesn\'t include any pages yet. Ask your administrator to set up your access.',
  },
};

export default function AccessState({ kind, backLabel, onBack }) {
  const { icon, title, body } = COPY[kind];
  return (
    <div className="access-state">
      <Card className="access-state-card" role="status">
        <Icon name={icon} size={32} className="access-state-icon" />
        <h3 className="access-state-title">{title}</h3>
        <p className="access-state-body">{body}</p>
        {onBack && backLabel && (
          <button type="button" className="resui-btn resui-btn--primary" onClick={onBack}>
            Go to {backLabel}
          </button>
        )}
      </Card>
    </div>
  );
}
